<template>
  <!--解决方案页面-->
  <div class="companyProfile">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>

    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <div class="menuBox"></div>
    <!--    内容-->
    <div class="contentBox" v-show="item.showData" v-for="item in itemData">
      <div class="contentTitle">
        {{item.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <el-image
            style="width: 578px; height: 700px"
            :src="item.img1"
            :fit="contain"></el-image>
        </div>
        <div class="rightImg">
          <div class="rightTopImg">
            <el-image
              style="width: 578px; height: 340px"
              :src="item.img2"
              :fit="contain"></el-image>
          </div>
          <div class="rightBottomImg">
            <div class="rightTopImg">
              <el-image
                style="width: 578px; height: 340px"
                :src="item.img3"
                :fit="contain"></el-image>
          </div>
        </div>
</div>
      </div>
      <div class="contentDetail">
        <div class="itemContent" >
          {{item.text2}}
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import Mun2 from "./image/mun2";
export default {
  name: "companyProfile",
  components: {Mun2},
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/jjfa.jpg",
      urlData:"",
      showData:{
        box1: false
      },
      numIndex: "1",
      numList : [
        {
          num : "1",
          tital : "对医院",
          path: "dyy"
        },
        {
          num : "2",
          tital : "对医生",
          path: "dys"
        },{
          num : "3",
          tital : "对患者",
          path: "dhz"
        }
      ],
      itemData:[{
        num : "1",
        path: "dyy",
        showData:false,
        img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
        img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
        img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
        text1:"舒适化诊疗中心",
        text2:"提升医院/科室竞争力：打造激光治疗特色，使医院/科室在专业领域更具差异化优势，树立技术领先、学术领先的形象，提升医院/科室的学术地位。\n" +
          "增加经济效益：口腔激光治疗具备专门的收费条目，且由于患者治疗接受度高，能够为医院/科室带来更多的经济收入。\n" +
          "促进科研与教学：为开展相关的科研项目提供了更多的研究方向和实践基础，产出更多的科研成果。同时也有利于教学工作的开展，培养更多优秀的人才。\n" +
          "优化治疗效果：口腔激光治疗的精准性和有效性有助于提高科室对各类口腔疾病的治疗水平，如激光辅助的口腔种植、牙周病治疗、根管治疗等为患者提供更优质的医疗服务，从而增加患者对医院/科室的信任和认可。"
      },
        {
          num : "2",
          path: "dys",
          showData:false,
          img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
          img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
          img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
          text1:"舒适化诊疗中心",
          text2:"提升专业技能：掌握口腔激光技术，丰富了治疗手段，拓宽了医生的专业知识和技能领域，使其在专业领域更具竞争力。\n" +
            "增加发展机会：在学术交流和研究方面，口腔激光治疗是一个新兴领域。通过参与相关研究和发表学术成果，能够获得更多的晋升以及学术发展机会。\n" +
            "提高治疗效果：激光治疗的精准性和有效性有助于医生更好地处理病例，获得更满意的治疗结果。同时相比传统方法，激光治疗有时能更快速地完成部分操作，提高了医生的工作效率。\n" +
            "更安全的工作环境：铒激光相对传统涡轮手机能够减少98%的气溶胶产生，使医生的工作环境更加友好和安全。\n" +
            "增强患者满意度：良好的治疗效果和患者体验能够显著提高患者对医生的满意度和信任度，有助于建立良好的医患关系，提升医生的声誉。"
        },
        {
          num : "3",
          path: "dhz",
          showData:false,
          img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
          img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
          img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
          text1:"舒适化诊疗中心",
          text2:"更舒适的体验：相较于传统治疗方法可能引起的强烈疼痛和不适，口腔激光治疗通常能大幅减轻患者在治疗过程中的疼痛感，让患者更容易接受治疗。\n" +
            "减少肿胀和疼痛：在手术或治疗过程中，激光能够烧灼小血管、淋巴管和暴露的神经末梢，从而降低术后肿胀和疼痛的程度。意味着患者术后的恢复更加顺利，不适感也相对较少。\n" +
            "缩短康复周期：由于激光对组织的损伤较小，能够刺激细胞的修复和再生，患者可以更快地恢复正常的口腔功能，减少因治疗对生活和工作的影响。\n" +
            "降低感染几率：激光的杀菌作用有助于清除病原体，创造一个相对清洁的治疗环境，从而显著降低感染的风险，并能够减少抗生素的使用。\n" +
            "改善美观效果：在一些涉及口腔美容的治疗中，如牙龈修整、牙龈脱色等，激光能够提供更精细、自然的效果，满足患者对美观的需求。"
        }
      ]
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'dyy')
      } else {
        let index = "1";
        if(that.urlData == 'dyy'){
          index = "1";
        } else if(that.urlData == 'dys'){
          index = "2";
        } else if(that.urlData == 'dhz'){
          index = "3";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      // that.showData.box1 = false;
      for(let item in that.itemData){
         let sj = that.itemData[item]
        if(sj.num == index){
          sj.showData = true;
        } else {
          sj.showData = false;
        }
      }
      // that.showData.box1 = true;
      // if(index == '1'){
      //   that.showData.box1 = true;
      // }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.contentDetail{
  margin-top: 20px;
}
.itemContent{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
  text-indent: 2em;
}
.leftImg{
  margin-top: 10px;
}
.rightTopImg{
  margin: 10px;
}
.contentImg{
  display: flex;
}
.contentTitle{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  margin-top: 30px;
  margin-bottom: 20px;;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
}
.companyProfile {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/companyProfile.vue